import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FieldArrayTypeConfig,
  FieldType,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { AccordionModule } from 'primeng/accordion';

export interface FormlyRepeatTableFieldConfig
  extends FieldArrayTypeConfig<FormlyFieldProps> {}

@Component({
  selector: 'kon-accordion-type',
  imports: [CommonModule, AccordionModule, FormlyModule],
  template: ` <div class="my-4">
    <p-accordion>
      @for (option of field.fieldGroup; track $index) {
        <p-accordion-panel [value]="$index">
          <p-accordion-header>{{ option.props?.label }}</p-accordion-header>
          <p-accordion-content>
            <div [ngClass]="option.fieldGroupClassName">
              @for (field of option.fieldGroup; track field) {
                <formly-field [field]="field"></formly-field>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyAccordionTypeComponent extends FieldType {}
